
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Klar`,
'deleteKey': `⌦ Radera`,
'downKey': `↓ Ner`,
'endKey': `⤓ Slut`,
'enterKey': `Ange`,
'escapeKey': `⎋ Flykt`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generera en 
          <code>LICENSE 
          </code> fil 
        `,
'homeKey': `⤒ Hem`,
'keyCommand': `⌘ Kommando/Win`,
'keyControl': `^ Kontroll`,
'keyOption': `⌥ Alternativ/Alt`,
'keyShift': `⇧ Skift`,
'leftKey': `← Vänster`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Uppslagning`,
'rightKey': `→ Höger`,
's00065e45db8c0441': `Se utvecklarverktyg för mer information`,
's001dd78415a91fa0': `Ränna för rullningslist`,
's002fa7d1054ed082': `Gränslös ruta`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazakstan`,
's01b56d233c6c5cac': `Sektionsindelning`,
's01d32b35baa3b676': `Författaren`,
's02106cc2ef0e7578': `Ny pin...`,
's02ab1ea8e5100fc1': `Markera valet som ett "dubbelriktat åsidosättande`,
's0312976fe9da5951': `Knapp`,
's03608a32f05eded2': `Nyp zoom`,
's036d35e03be98d22': `Matematiskt djup`,
's037b1dc850a89273': `Alternativt under`,
's0396202b716732ec': `Markera valet som genomslaget`,
's03f49e598ffb11cc': `Polsk`,
's0448f1059fa01720': `Spara, dela eller skriv ut din explorable. Redigera information som titel, språk eller licens.`,
's0458872c43beadef': `Infoga rad före`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Avstånd mellan ord`,
's05e9759cfd99c48f': `Motivera`,
's063fa5a0a4903bf4': `I sidled, från vänster till höger`,
's064339c229374050': `Kodning`,
's06634274f19b0572': `Val av stift`,
's06743b24499f0035': `Ankarcentrum`,
's07808b0ca6da8fef': `Inhägnad webbplats`,
's07970793b21351fd': `Ruby basbehållare`,
's079cf7850d9327f0': `Typsnitt`,
's07aa10850d9ddcc7': `Form`,
's07e6118e838b2e23': `Navigering`,
's0816468df86e4036': `Öppnar inställningarna`,
's082869038c117fe5': `Portugisiska (Brasilien)`,
's086e6c267ade2609': `Mättnad`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Ljud`,
's0978fb5ba3145996': `Infoga en lista (oordnad)`,
's09c3f1d21de14ae1': `Markera urvalet som understruket`,
's0a2d91c6720033e9': `Trimning av textavstånd`,
's0a3ddcba94027d95': `Objektets passform`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Infoga en navigering`,
's0a7db790db1fc45c': `Markera urvalet som ett spann`,
's0b1271f50a77dc73': `Innehållsruta`,
's0b24d08ea349b455': `Allt kan du infoga. Först kommer icke-interaktiva element som listor eller bilder, därefter kommer interaktiva element som kallas widgets. Du kan få fram nya genom att klicka på sökfältet.`,
's0bdca49248ba4820': `Genvägar`,
's0befccf152b6c0a9': `Orientering från metadata`,
's0c11e479416c8421': `Infoga en bildtext till tabellen`,
's0c27336067c59611': `Padding för skrollning`,
's0c4593d81f147042': `Baslinje`,
's0c4b2e98d4ab7f5a': `App-kommandon`,
's0c883713b83616a8': `Spara det aktiva dokumentet`,
's0ca5c0460199cba1': `Förkortning`,
's0cf10c4f40588f8d': `Tabell Bildtext`,
's0d86afa3c6a1e28b': `Flex riktning`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Ditt utforskbara dokument. Här kan du skriva text och kopiera/klistra in, redigera etc.`,
's0dc452999c129e15': `Aktivera live reload`,
's0de0febab8a4beaf': `Fel vid läsning av detta paket`,
's0e44968489e076a8': `Kinesiska`,
's0e4862e87c7d53ce': `Markera urvalet som en offert`,
's0e6ea8870dbddab2': `Dokumentkommandon`,
's0ee28503778e4c0c': `Senaste baslinje`,
's0ef01c03299bbb83': `Dekoration`,
's0f17f32919661cff': `Mongoliska`,
's0f350bc4e538e3ea': `Ord`,
's105a06836c40fcb4': `Ställ in filter, färg och blandning av valda element`,
's106b274b5af798e5': `Meningar`,
's1082e1649793dca9': `Markera urvalet som en definierad term`,
's10f3845975a0351e': `Redigera metadata`,
's1125d159f7e64df5': `Display`,
's11326fd2590f4e5e': `Standard`,
's1155ec07a221e739': `Rullningslist`,
's1173bf7a3e0b74c9': `Minsta (y)`,
's1177237a3e0e548c': `Minsta (x)`,
's1219d97b49650c05': `Synlighet`,
's123bea44f38abccf': `Infoga objekt`,
's1245e2cb9f20197e': `Rikta in`,
's12946ec1b850962c': `Infoga kolumn efter`,
's1351209ef74ee729': `Spänn över alla kolumner`,
's13c60cb409e8cb6f': `Rikta in mitten`,
's13ebd619c8a06a6d': `Automatiska rader i rutnätet`,
's13ef8ca26ca8861b': `Klippt element`,
's151bc2eea7a032a4': `-förändrad-`,
's153bc3c3aa39587b': `Tabell Huvud`,
's156647179b21d351': `Infoga en tabellkropp`,
's158b6ec6b1fffcb2': `Avbrott efter`,
's15d0c0657c1ee08c': `API-nyckel`,
's1626a7e10a9f9dcc': `Ställer in urvalets teckensnittsfamilj`,
's1637c7d1a30629e2': `Border Box`,
's1641ab440bf4daa4': `Uppdatera detta widgetpaket`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avancerat: Visa paket med versioner som 0.x.x i pakethanteraren`,
's16b9446e3a70e1f4': `Attribut`,
's16f205466761e583': `Ingen optisk storlek på teckensnitt`,
's16f2f1c2c516d307': `Öppna ett dokument`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licens`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Ta bort fält`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Skapa paket`,
's18d5c44aae3dc82a': `Online vid redigering`,
's1988d71ef8060edf': `Infoga en tabellrad`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Översikt`,
's1a1acc902e6668e0': `Visa avancerad textformatering`,
's1a5230a71d9285c1': `Fångst`,
's1aa1cb63ad44bc6f': `Avstånd mellan kolumner`,
's1af8b67d1c85c811': `Utrymme mellan`,
's1b4a36fce2456660': `Fontfamilj`,
's1c246045629b0016': `Markera valet som en radering`,
's1c3fc313a9184670': `Offentlig länk`,
's1c65f5004a07dcfa': `Skotsk gaeliska`,
's1c690963f1e2df00': `Plattformsspecifikt utseende`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Vill du ha en kort, guidad tur?`,
's1d19244f549ec535': `Utbildning`,
's1d5c7b28e8b50d6d': `Associate Deg.`,
's1db591f5a54dbfd3': `Innehåll Box`,
's1dbb9f50e16c92a3': `Radie för kantlinje`,
's1dfb744260fb3a01': `Dubbelriktad isolator`,
's1e9c2c654732cc5f': `Byelorussian`,
's1eaccbf2d6af8ab5': `Information om`,
's1efbfc3937d565bd': `Bakgrund`,
's1f2b49c1bca2035d': `Katalanska`,
's1f74bdf32b51a5fc': `Bakgrundsbild`,
's1f7698c061c208c9': `Öppna`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsikanska`,
's21d61916eb8d137d': `Bordskropp`,
's21d723a1dbcd89c8': `Javanesiska`,
's21f8a2eaf5a70749': `Infoga en etikett`,
's2206c42e5b835e6e': `Markera valet som en förkortning`,
's22a2348c46a912a0': `Infoga ett avsnitt`,
's233ae776268cd44b': `Företag`,
's236ed7ba747099b0': `Teckensnittets vikt`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Text`,
's24949d7adbb5a098': `Verktygslåda`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Kräva tillskrivning?`,
's255857544a9d5ec0': `Återställning`,
's255c77900f2b5e0f': `Färgschema`,
's256ab831a48c941c': `Tar bort all textformatering från markeringen`,
's2591806d7b222591': `Återställ ändringar`,
's25e1a07e454c2c11': `Rutnät`,
's262abbaf1d05f009': `Mjukt ljus`,
's266935f2447fcd98': `Över vänster`,
's268ecd1cef45a9a8': `Är du säker?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Ljusare`,
's27076e66c5d483ba': `Vertikal justering`,
's2712dc5641a33226': `Paketregisterkonton är avsedda för utvecklare och gör att du kan konfigurera ett
          eller flera register`,
's27cc88818cc46ff6': `Stabilt`,
's281d957112b10f12': `Redigera dokumentets HTML direkt`,
's28b6246ce616a548': `Infoga en kolumngrupp i en tabell`,
's29a1c26521879b9f': `Skala ner`,
's29acfd2778e8c377': `Dölj avancerad textformatering`,
's29b24c06315e9343': `Infoga en inmatning`,
's29eb103449472e3b': `Infoga en rubrik (nivå 3)`,
's29ee7434494a0dfe': `Infoga en rubrik (nivå 2)`,
's29f21c34494d614d': `Infoga en rubrik (nivå 1)`,
's29fbfc3449557f72': `Infoga en rubrik (nivå 6)`,
's29ff743449588131': `Infoga en rubrik (nivå 5)`,
's2a031834495bcdb4': `Infoga en rubrik (nivå 4)`,
's2a75c946ef4dcab7': `Övrigt`,
's2b2ae20d26f78ac2': `Block`,
's2b8f50c64be440f7': str`Välj 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Beställning`,
's2bad2d24def4aa0b': `Radbrytning (CJK språk)`,
's2ceb11be2290bb1b': `Avbryt`,
's2ced8e8fafb499f6': `Ta bort element`,
's2d986d31f8d67357': `Infoga en fältuppsättning`,
's2d995a37cf5e4995': `Infoga ett NoScript`,
's2de969afacdaa7a6': `Form`,
's2df075aface0dab8': `Aktie`,
's2e192b19ed15fcf6': `Sidan`,
's2e39b99cf23606fa': `Ställ in layouten för de valda elementen`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Överflöde (y)`,
's2edd6688a65e21f0': `Överflöde (x)`,
's2f0bcdffc92a786b': `Flottör höger`,
's2f2044f2431a32d5': `Rubrik`,
's2f4d4bfbc466d91f': `Albanska`,
's2f8da2cb5f236588': `Namnet på ditt paket. Måste vara scoped, t.ex. \`@org/pkg\`. `,
's30cce87854901922': `Förskola`,
's3124653c272f054c': `Kolumnregelns färg`,
's314a4f7685c8e824': `Alltid`,
's31c06e226322f065': `Undvik föräldralösa barn`,
's323dcde72b850272': `Allmän tillgång`,
's32911e52ee8ac745': `Sätt i en kortplats`,
's337a1e9022a8d19f': `Tabell`,
's33c1450d2822bb0f': `Infoga en bildtext`,
's33c18d5a4cbffa2a': `Irländska`,
's33f85f24c0f5f008': `Spara`,
's342b0cabfa672822': `Hjälp användaren att hitta din widget`,
's3437e0d9899e7ae1': `Skicka telemetridata om din användning av WebWriter.`,
's344ea8f4939cdc98': `Färg`,
's34dcda3b0f9d5a98': `Växla webbadress`,
's34f724979a124c50': `Ställer in bakgrundsfärgen för den markerade texten`,
's355b21b89ce5d9c5': `Detaljer`,
's35ae5f4e0fa2777b': `Anpassad justering`,
's35aeaff1425bca9e': `WebWriter stöder inte media av typen `,
's35c3125c7750681e': `Blockcitat`,
's3643189d1abbb7f4': `Kod`,
's3649bacefe731bf6': `Växla verktygslåda`,
's365280e16a8ea32d': `Kopiera urvalet`,
's366991b9c9287765': `Rätt`,
's36a194e38d653a26': `Annotering av data`,
's36b3cefdcb897f15': `Perspektiv`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Ordnad lista`,
's37a8c35f6581da5f': `Inget ankare`,
's37fa3b9cd51c2dfd': `Ställer in urvalets teckenstorlek`,
's380d17664bb69531': `Infoga kolumn före`,
's3815184eb09f0dcf': `Markör`,
's382a2aa3984474dd': `Skapa`,
's38980f98cb07ceb8': `Spara det aktiva dokumentet som en kopia`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Ruby position`,
's3a5ca02f282d247e': `Dela...`,
's3ae67088bbefba98': `Paket`,
's3b0ab4b52326316f': `Ljus`,
's3b3ea038c5d3bb06': `Division`,
's3bdad99768e11911': `Utforskningsbar`,
's3cb47df8290fa94c': `Infoga ett alternativ`,
's3cf89cb47fdde7e9': `Länk`,
's3d09398e555ee5f9': `Avancerade alternativ`,
's3d249bb480032121': `Lista`,
's3d3efd1e19bdcfb4': `Datum/tid-annotering`,
's3d6a732c792ccb9e': `Ruby-annotering`,
's3d93f9ea0c5a13fa': `Bild`,
's3d9548e211b958ce': `Hoppa över överlappningar`,
's3e092e9d1ee2c5bb': `Klämma`,
's3e78ddc9a48a608d': `Söt`,
's3eb6d1e6e79ed7c4': `Inga dokument hittades`,
's3eca5a034978754b': `Ta bort markeringen`,
's3f06e9abb6ebcb79': `Karaktärer`,
's3f1e7a3f2b283d3b': `Marginal`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Infoga en artikel`,
's3fd83566dd643d10': `Infoga en teckenförklaring`,
's3fe72792941c18f9': `Text längst ner`,
's3ffcdc5db5e7d0c5': `Omvänd`,
's40e3826b7f74a3b5': `Pan (höger)`,
's40f07d7859284a44': `Dominerande baslinje`,
's4101ada154a1b958': `Mellan`,
's410c465a5993f82d': `Möjlighet till linjebrytning`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Förhandsgranskning`,
's418f2020fe996832': `Bekräfta ändringar`,
's41c724f0698148e9': `Markera valet som en tangentbordsgenväg`,
's41f65a763f8e44ab': `Tabellhuvudgrupp`,
's42721130228841b0': `Stroke box`,
's429bd646f1cf8bc6': `Med Grammar LLM-konton kan du använda Grammar LLM API för att korrigera grammatik i text.`,
's429dd933ba95549b': `Infoga en adress`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Infoga rad efter`,
's430831017f3f0499': `Skevhet (y)`,
's430bd5017f42511c': `Skevhet (x)`,
's433ba70286202ceb': `Bryt alla`,
's441b20a8a50e36b4': `Makedonska`,
's445b8acb9206db6e': `Kassera och avbryt`,
's446a924922651ea0': `Textens betoning`,
's44cdba92713de38e': `Rutnätsområde`,
's45518abd911471d0': `Kroatiska`,
's456a8d744313852a': `Utrymme runt`,
's4634541f5056a546': `Abchaziska`,
's46d4abe6255cb9e1': `Tilldela genväg igen`,
's4730c232e7209c40': `Trimma båda`,
's474f0eec369d02a4': `Exempel på utdata`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Markera valet som en datum-/tidsanteckning`,
's47ebf3a8fb3b10c1': `Orientering`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Alternativ`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Skugga av text`,
's4993444bfd3f3e5e': `Kollaps`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Mask`,
's49dd67aed00029ef': `Matematik`,
's49e763aed00877a8': `Huvud`,
's4a894f57eba1cf1e': `Kortkommando på tangentbordet`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Hårt ljus`,
's4b2c143acf931122': `Linjehöjd`,
's4b58c01e2578f5e4': `Legend`,
's4bbff4e008690da1': `Undvik sida`,
's4c1535f316305a2a': `Inspektera urvalet`,
's4c402ff5355fd310': `Dubbelriktad överstyrning`,
's4caed5b7a7e5d89b': `Engelska`,
's4cb38675a21b2c98': `Egenskapstyp som inte stöds '\${desc.type}' (bearbetning som JSON)`,
's4cc8391f172c0cdf': `Avfärda turnén`,
's4d528b416ac8dee2': `Infoga en rubrikgrupp`,
's4d546f6c87128d5b': `Rymden först`,
's4dcb9315f6527f9c': `Kör på omladdning`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Fel vid anslutning`,
's4e361bf8eef3759a': `Ordbrytning`,
's4ea0f21fc2a338a1': `Flytta upp`,
's4eace13b3ed74187': `Kommentar på sidan`,
's4efee5b48a4593cb': `Slinga`,
's4f26e7cb7c0a8318': `Vektorritning`,
's4fd2e638aabb0bb3': `WebWriter stöder inbäddning av många olika källor. Klistra bara in en länk till
          innehåll från:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thailändsk`,
's5015a8fb33b98872': `Tunn`,
's50489ffb1bde152e': `Insättning`,
's5068560b8d39663d': `Klickbar karta`,
's517acbf1f96324f9': `Vikt`,
's523eb9043213ff0d': `Kursiv stil`,
's52777d434baeed9b': `Infoga en förloppsindikator`,
's52af5d7ac34c2163': `Tabellrad`,
's52e0bdc3ee304436': `Sätt in en mätare`,
's531056f039febd39': `Infoga en markering`,
's536695196d0b6dc3': `Färöiska`,
's542fcefa0bbaed86': `Öppna eller stäng verktygslådan (endast på smala skärmar, annars är verktygslådan alltid synlig på sidan).`,
's5432ad3c84273229': `Figur`,
's543906d1db8b2283': `Redigera `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodjanska`,
's54897f2764b0e4d0': `Installera detta widgetpaket`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Markera urvalet som mycket viktigt`,
's55905c735052d295': `Tematisk paus`,
's5590dbf7e425789d': `Etikett`,
's5623aa2f83b05c76': `Tibetanska`,
's564d1648b1ceee9f': `Uppdaterad`,
's565cd5ffb0158c46': `Undvik region`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Gå tillbaka`,
's5787c6d5b3b5541a': `Klippväg`,
's579c69f419b6caef': `Smidig`,
's587ac858dd80f6fa': `Inskription`,
's58bec0ecd4f3ccd4': `Strikt`,
's59404f5593c32fdc': `Skärmning av teckensnitt`,
's5941292bb77281ab': `Norska Bokmål`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Markera urvalet med en dataannotering`,
's5a356677b61a6b7e': `Moldaviska`,
's5b474b5c0ac0c7c4': `Tabell kolumn grupp`,
's5b517ac216f9ee62': `I sidled`,
's5b8cc9bb61ddce15': `Infoga ett stycke`,
's5bba2ac2e53bd1fd': `Kirgizistan`,
's5be80ad6b8301710': `Inline start`,
's5c1ecf88259b79f9': `Presentation`,
's5c2a1a52c0389c30': `Ingenjörskonst`,
's5c63af7695445fcf': `Text Stil`,
's5d18ca4c3111be6f': `Infoga ett tabellhuvud`,
's5d87c1e588f48d90': `Övning`,
's5d929ff1619ac0c9': `Sök`,
's5da52af9b083c29a': `Modell`,
's5dc77784260a7236': `bil`,
's5e27738a2e8eb763': `Registrera dig`,
's5e2cba97c0d971bd': `Ladda om paket`,
's5e53415a6d5719ad': `Samhällsvetenskap`,
's5e6a7a0c30d2a270': `Hoppa över överlappningar (auto)`,
's5e9e8e4d21bafedc': `Produktion av livsmedel`,
's5ed03bb1f3a15949': `Bild`,
's5f43af3669b1e098': `Källa`,
's5feaf7fd7ee567c8': `Bryt ord`,
's600fd23c9ce971e8': `Skriv ut det aktiva dokumentet`,
's602bbd28dae2c60f': `Självstart`,
's60ff598dfcf2c773': `Under höger`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tabell Kolumn`,
's6196153c4b0c1ea0': `Installera`,
's61c017f6d5c303af': `Frisiska`,
's61ded17ca3f48c82': `Understreckad offset`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Val av kopia`,
's624e31cd4f1b89d4': `Smidig scrollning`,
's626daf42b1ab7df7': `Justera vänster`,
's6280bf993915c57a': `Skrollmarginal`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Beskrivning`,
's63dfc5b1c1c27849': `Jiddisch`,
's63e03c70f67ebf9c': `Sammanhang`,
's63e71d20d1eaca93': `Tysk`,
's640bc7710d0143ce': `Återställ den senaste ogjorda ändringen i det aktiva dokumentet`,
's64dc1fc7e3db45c9': `Skapa ett nytt dokument`,
's65ac276544ba33cd': `SVG-fil`,
's66765c420ee578e4': `Utrymme jämnt`,
's669b18c6d2d9c95b': `Ingen`,
's6747dbf4ad6063ba': `Självändamål`,
's6787497df07fa97e': `Kan rulla över stopp`,
's67c2b60a506a09e4': `Sekundär utgåva.`,
's680bd4d926cd5a84': `Bevara 3D`,
's6827930ef1aeaf99': `Bas-URL`,
's684a16f3c711394d': `Över höger`,
's687e27f036a71b32': `Isolera`,
's68b87d7b61052dc3': `Tabellrad`,
's68e0e3a2bab7ce3e': `Undvik`,
's690da6b432987c6f': `Säkerhetskopierar ändringar i det aktuella dokumentet automatiskt. Ändringarna återställs när WebWriter laddas om.`,
's69311c4e25074fb3': `Högstadiet`,
's697400b541fbc3cd': `Under`,
's6988ab5d47593a26': `Du har den senaste versionen av WebWriter.`,
's69a49786a8009f43': `Hitta paket...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Omslag`,
's69fbbdb8ad2a084a': `Mörka`,
's6a31eff1ec4f71ad': `Göm baksidan av ansiktet (3D)`,
's6ac62e1c8c66f3bb': `Kompakt superscr.`,
's6b585ba37cdb8260': `Ärva`,
's6b61f8abf89586be': `Hebreiska`,
's6bd7a02fdf93e653': `Justera innehållet`,
's6cfc66b824ea05ba': `Skarpa kanter`,
's6d02dc19e21eb49c': `Topp`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamesiska`,
's6d8b3b8047ed378d': `Mixa blandningsläge`,
's6d8c02aee480af7a': `Meny`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Infoga en stil`,
's6e288a119281f4c2': `Rendering av text`,
's6e4c20c6debcd5ca': `Anpassad motivering`,
's6f84199e62584905': `Förformaterad text`,
's6fb3053e7244d326': `Övriga områden`,
's70178e04a3b691b6': `Öppna inställningar`,
's7031ca562378bde6': `Geometrisk precision`,
's7060970b5ed20a58': `Interaktivitet`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Visa instabila paket`,
's71dec51005acc1e4': `Tät rad`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Denna enhet`,
's736904f276fbd441': `Naturvetenskap`,
's739544d0c858c633': str`Eller släpp 
          ${0} här 
        `,
's73cb20c838e761e1': `Val av snitt`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pixelerad`,
's743f778233e42a3f': `Lägg till en bisats`,
's744d993d03f29851': `Skärm`,
's748c0074eff45884': `Manipulation`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Fyll i rutan`,
's75109f5307578a61': `Välkommen till WebWriter`,
's75a27f43413e02c5': `Franska`,
's75d83fc3f0cfab40': `Huvud`,
's762e5704cc84089d': `Ange andra stilalternativ för valda element`,
's77318393dfdb0775': `Ta bort raden`,
's77e594ddcc10c774': `Tillåta kommersiell användning?`,
's782eac2b3e80323d': `Markera urvalet som betonat`,
's782f286a79cca35d': `Relativ`,
's78673a3539cb1915': `Överst till vänster`,
's78789724e789221c': `Storlek`,
's789ff24c8f03f1a4': `Avstånd mellan bokstäver`,
's7995733bf97c01cc': `Serbokroatiska`,
's7a99528e7b64635a': `Occitanska`,
's7aaf0c06e69600f1': `Fel med `,
's7ae49e142487766c': `Gemenskapens tillträde`,
's7af555180b30a947': `Öppna utvecklarverktygen`,
's7b4ba250601b8667': `Infoga en mall`,
's7b560d8693ed8f42': `Stående`,
's7b9994904c4f5b54': `Tajik`,
's7bdf0fd5b014d36c': `Stark betydelse`,
's7beb1e77e82363eb': `Ångra den senaste ändringen i det aktiva dokumentet`,
's7c61118554a0ec36': `Maximalt (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Företag`,
's7cfe12cd14df9950': `Logga ut`,
's7d27db3c9639c6dd': `Alternativ`,
's7d8103f6f06f83d6': `Stoppning`,
's7d864465dddbb50d': `Tillåt storleksändring`,
's7de0e28d6c309a4e': `Tillåt touch-åtgärder`,
's7dea785045c3cc74': `Tryck på en ny tangentkombination...`,
's7e0b179d4d1414eb': `Ange länk`,
's7e6570f2f1ae320f': `Syntetisera typsnitt`,
's7ecb1f29332293e5': `Baslinje för justering`,
's7ed13ccddb1bf3c3': `Överlägg`,
's7edbe0b213199995': `Kandidatexamen`,
's7ede1c55e35ce9d6': `Simulering`,
's7f09197a4814079b': `Ange interaktivitetsalternativ för valda element`,
's7f326a142e856656': `Stil`,
's7fcb35d23be1e643': `Fältuppsättning`,
's80570196a9ce6d11': `Aktivera telemetri`,
's806f84eb0ace116e': `Se vad du har valt och ändra det. Kopiera, klippa ut, klistra in, fästa eller göra layoutändringar. Erbjuder olika alternativ beroende på ditt val, t.ex. formatering av text.`,
's80a42b81c52d4d8f': `Caret färg`,
's80b71fc6f43c5ce1': `Lösa`,
's812cbda653daaeba': `Denna funktion är inte implementerad ännu`,
's814d528c8af55807': `Definition listobjekt`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Fortsätt`,
's8247d32213e35f24': `Infoga en huvud`,
's82665b2ffabc9c0a': `Webbplats`,
's828b1ecea8715884': `Panna (vänster)`,
's833bd0422a7ef95d': `Flikstorlek`,
's83420ad7b6a14db5': `Växla mellan utvecklingsverktyg`,
's83c15613b6f6f3c8': `Endast online`,
's83cd32b685ccc9b7': `Kontroller`,
's83f26d02dd7aa681': `Synlig`,
's840fa49e8989c028': `Position/form`,
's844a76d1843ceb3c': `Återställ till standard`,
's84e4e8ae645b82ac': `Överst till höger (y)`,
's84e9c7f8785ca60b': `Infoga ett formulär`,
's8517ae4da104b004': `Tabell Kolumn Grupp`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licens som Creative Commons OER?`,
's85f9aa6d3ea0e421': `Tabellens sidfotgrupp`,
's864b0e6270e97246': `Markera valet som en sidokommentar`,
's8670e5ad3bf0dcf8': `Spara som`,
's8688d74dd3716d6e': `Kortkommandon för kommandon på tangentbordet`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Marginal för form`,
's87cefc710b3567fb': `Innehåller`,
's88676f992b2965db': `Sträck ut cellinnehållet`,
's886897f2fd4edb99': `Dolda`,
's886c5db2a5579873': `Koncept`,
's888c71e8fcb916d3': `Autospara`,
's88a62d29529948fb': `Infoga en tabell`,
's89950d86c8004d4b': `Hoppa över inga överlappningar`,
's89bca7498f20e041': `Bakgrundsklipp`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Bryt före`,
's8a4ff2bd9c13498c': `Skiva`,
's8a6585c48ea104e9': `Dölj tomma celler`,
's8a9eb438abac7c6a': `Etiketter`,
's8b0432eecbd8b034': `Uppdatering`,
's8b7580c35e2aef87': `Överst till vänster (y)`,
's8bc4affa761aa8a2': `Infoga en bild`,
's8c7f51cb067644c7': `Datalista`,
's8d342ecaa9e75b9b': `Förhållande`,
's8d797888455f4147': `Pausutrymmen`,
's8d83386457e91813': `Ångra/återställ dina ändringar eller förhandsgranska från elevens perspektiv.`,
's8d8643013a7754d1': `Justera texten`,
's8df30fe2a50d3479': `Infoga en möjlighet till radbrytning`,
's8e715248c3a78446': `Skär bort urvalet`,
's8f29e48d6b9a1aa8': `Infoga en rad med tabellhuvud`,
's8f4be9f086eb530f': `Ångra`,
's8f533296a536965e': `Spara som...`,
's8fad58c831ecf017': `Ruby textbehållare`,
's8ffe7abcbed8eb43': `Vertikal, från vänster till höger`,
's90105521fcc40453': `Med WebWriter Cloud-konton kan du lagra dokument online och dela dem med dina
          studenter. Lägg till ett konto här så blir det tillgängligt som en plats för att spara,
          ladda, dela och öppna dokument.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Palett för teckensnitt`,
's90f7c1cf501ea0a7': `Färgförskjutning`,
's91093e0b087911ba': `Position för betoning`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Infoga inbäddning`,
's9219acd5bef6269e': `Under vänster`,
's92548405912d46bf': `Skrolla snäppjustering (y)`,
's9258280591309342': `Scroll snap align (x)`,
's927d796559f49439': `Bakgrund Ursprung`,
's92b177e579ef7b97': `Betoning`,
's92f846b9be2e8e8d': `Markera urvalet som kursivt`,
's93566b84230af4f5': `Infoga en bild`,
's936aa0b239679585': `Infoga ett tematiskt avbrott (visas vanligtvis som en horisontell linje)`,
's9370dc6afa716b57': `Gräns`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Definierad löptid`,
's9485af2e7cd9418f': `Grundskola`,
's94d2eee44b292567': `Växla mellan avancerade alternativ`,
's94d61907ee22a8c1': `Koreanska`,
's94eb1effbbb6498b': `Överflöde`,
's951aa3a6439f1271': `Lista markör`,
's9565553d163fc92a': `Skript`,
's957787fc6b7ea5c0': `Pan (upp)`,
's95c161f68e5180a5': `Inspektera urval`,
's95d56e58f816d211': `Holländska`,
's95d8e41a64635c7c': `Vitt utrymme`,
's95de7e1eff6c053e': `Horisontell, uppifrån och ner`,
's960d3a90ac199368': `Rätoromanska`,
's96532132a29dd542': `Infoga ljud`,
's96a045dcade75ad0': `Kolumn tät`,
's9781a5bb3fcb26a3': `Välj först ett företag`,
's978522fbc9577a7e': `Somaliska`,
's97881699a2b21d5b': `Avstånd mellan raderna`,
's97aa76056a81bd36': `Mätvärden`,
's986facb3ecc9602c': `I sidled, från höger till vänster`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Extern fil`,
's98977a87d1b93941': `Återställ information, stilar och skript`,
's990d0e0fa2ab00b5': `Galiciska`,
's99229574e5692f19': `Grönländska`,
's99a990f3841ad283': `Filer av `,
's99b38e000175cc84': `Genomstruken`,
's99f110d27e30b289': `Titel`,
's9ab10fbf4c7a7322': `Position för understrykning`,
's9abadcc828884d7b': `Textområde`,
's9b7cd8860c8fc922': str`
          ${0}
          kommer att skrivas över. Är du säker på det? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Bakgrundsfärg`,
's9c8df9626d152d5a': `Definition lista term`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabell kolumn`,
's9cf68f87b8e6122f': `Azerbajdzjanska`,
's9d167ef77aed79b6': `Lager`,
's9d2d00982edafabb': `Turkiska`,
's9d430adc5be110e9': `Rad omvänd`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Radering`,
's9df571714a1efb44': `En autosparad version av denna explorable finns tillgänglig. Ladda den?`,
's9e28faa598332e2b': `Infoga video`,
's9e3dbb678150edd4': `Ange teckensnittsfamilj`,
's9e40e59654c8ad67': `Kolumn`,
's9e85800d3700e31c': `Spår`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variant av teckensnitt`,
's9f1ecdb3061d9cbc': `Bevara utrymmen`,
's9faf26107ed49fb9': `Infoga en tabellcell`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Övergång`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Canvas`,
'sa00df4e39c72d3b4': str`
          ${0} stöds inte 
        `,
'sa013e119fec906fb': `Rad`,
'sa01e7bf33563ef72': `Bakgrund Bilaga`,
'sa126cf8c627cec1e': `Rendering av bilder`,
'sa13f72278add7513': `Under höger`,
'sa1647e3b36ec08d7': `Kombinera upprätt`,
'sa172190ea21f9b1c': `Gå till inställningarna, öppna ett utforskbart objekt eller skapa ett nytt.`,
'sa1c6c459b9b5115c': `Absolut`,
'sa2cba871f6cdd99f': `Assamesiska`,
'sa2eff4dad1c119f1': `Mall för rutnät`,
'sa30c12014e955946': `Ryska`,
'sa30f1981fd1cd441': `Fontstorlek`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Infoga en sidfot`,
'sa37fee6a52d18063': `Ta bort dokument`,
'sa39c7ac1d37f3bce': `Markera urvalet som ett "dubbelriktat isolat`,
'sa3b4c01623211544': `Kraft`,
'sa40fd43756fa8913': `Persiska`,
'sa417644bef21a9aa': `Namnlöst tema`,
'sa43800e28be1bdbc': `Dekorationsfärg`,
'sa477cb1825dceb3b': `sudanesisk`,
'sa492a51a707930fa': `Infoga ett blockcitat`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Bildtext längst ner`,
'sa50d3c35533f1d99': `Alla områden`,
'sa53c5cb03a8fda50': `Fäst markeringen som ett utdrag i paletten`,
'sa557ae6bee9148a6': `Framsteg`,
'sa589e1df65dde0ec': `Ange storlek, utfyllnad och marginaler för de markerade elementen`,
'sa5c371b4bb75e590': `Vänster`,
'sa5c80e623459ffe4': `Infoga en rubrik`,
'sa5df1bcdba46c3fb': `Bildtext`,
'sa602e3fd3f2d98fd': `Animation`,
'sa644d580d8a11e60': `Ruby-anpassning`,
'sa645d315510dc09e': `Välj sökväg från disketten`,
'sa65d4ad99f1d8c06': `Ställ in textbakgrund`,
'sa6607436f60ccc1a': `Estniska`,
'sa6f8d27bca557059': `Flytta meta/länk/style-element upp/ner till detta element`,
'sa757645ad842da97': `Bevara pauser`,
'sa75b95980cd80e78': `Redaktör`,
'sa7698b3d20a6d1ec': `Skrolla`,
'sa778acc33947c7b8': `Avsluta turnén`,
'sa78a67272a4a6f95': `Matematisk formel`,
'sa79167651dce1e80': `Alternativ text`,
'sa7af797a46c7d09a': `Tabellens sidfot`,
'sa7dbe35b758c138d': `Infoga en duk`,
'sa7dc6b8ef3f595dc': `Infoga en källa`,
'sa8279f8211b3950d': `Bevara pauser och mellanrum`,
'sa8b55cab62e439b5': `Ta bort kolumnen`,
'sa8bbe0197d31b423': `Kort beskrivning`,
'sa9ff3b762365abe6': `Transformera ursprung (z)`,
'saa02e3762368ff35': `Transformera ursprung (y)`,
'saa065776236bfa28': `Transformera ursprung (x)`,
'saa33768e03c45fc8': `Filstorlek`,
'saaad98061a20ac39': `Infoga en matematisk formel`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternativt över`,
'saaec15c97a9e4245': `Kolumn bakåt`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Snap-upplösning pixlar`,
'sab55faae8e165407': `Padding&lt;br&gt; som gap`,
'sab5e7d2a069a2951': `Yrkesbevis.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Justera höger`,
'sac895c732f350ac5': `Mörk`,
'saced41ddda8b2354': `Flexibel bas`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompakt matematik`,
'sadd352cc7f6f2307': `Åt sidan`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Svenska`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Infoga en beskrivningslista (ordlista, termlista)`,
'saf3da7c95cb17260': `Markera urvalet som ett upphöjt tecken`,
'saf440a0a592f2835': `Uppdatering till`,
'saf9e5134ba1a7d30': `Skrolla snäpp`,
'safc6f203342d09e2': `Växlar förhandsgranskningen för det aktiva dokumentet`,
'sb0a7e3adf4a125ee': `Överst till höger`,
'sb0a974028c99ca6d': `Tillåta anpassningar?`,
'sb0d4f0f7993cf085': `Ange teckenstorlek`,
'sb0f3327210fe18fc': `Kolumner`,
'sb0f93c1c60c0249a': `Ruby bas`,
'sb1494c08c8c720d1': `Ange textfärg`,
'sb19611adbc88f711': `Avancerad: Visa kommandon för källredigering, t.ex. för att visa dokumentets HTML eller för att lägga till egna stilar och skript.`,
'sb206d700d26b14ff': `Understrykning`,
'sb233557012dcb328': `Flytta ner`,
'sb26035b596566abf': `Ej namngiven`,
'sb2cda80610c8d6ea': `Utrymme alla`,
'sb2dc787b0983ebc6': `Litauiska`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centrum`,
'sb3ba3276ae93627c': `Infoga ett förformaterat textblock`,
'sb430f5b4824de0d3': `Välj en layout`,
'sb43db07b24da018a': `Amhariska`,
'sb45f9fb4dba6e71a': `Avaktivera`,
'sb4e003a459464d85': `Kurdiska`,
'sb4f0310e6787d098': `Uzbekiska`,
'sb4f1dffbb6be6302': `Klar`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Delade cellgränser`,
'sb5e9e1776242b028': `Interaktioner`,
'sb60bc1250aad44c1': `Spännvidd`,
'sb60dd9d23d31ee66': `Doktorsexamen`,
'sb6103872073d369e': `Infoga detaljer`,
'sb616811735bfbafd': `Bordscell`,
'sb628960829e223bb': `Hoppa över alla överlappningar`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Applicera och importera`,
'sb66e2181a7b5738a': `Genom att aktivera telemetri tillåter du insamling och lagring av data i enlighet med våra`,
'sb67e0e7c0869f982': `Skillnad`,
'sb68e83cda6c85af8': `Tabellhuvud`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dekorationens tjocklek`,
'sb70c17f7899f9b01': `Latinska`,
'sb71941f552f3504d': `Ställ in specialvärde`,
'sb740eab4afd5a710': `Automatiskt flöde i nätet`,
'sb741b6e0ca589122': `Återgå till lager`,
'sb7c77d0415de05cf': `Kör tester`,
'sb7fb7568f6883ab8': `Dela det aktiva dokumentet`,
'sb85774dc5d18ff0f': `Bekräfta`,
'sb85b1e36579852a6': `Ogiltig e-postadress eller ogiltigt lösenord`,
'sb884fa76bfc55429': `Arabiska`,
'sb8a3d4df7d1c5e6b': `Balans`,
'sb8f610a0e8df91fc': `Luminositet`,
'sb8f855b49234b81b': `Tillämpa`,
'sb905da066c10182c': `Dessutom mörkare`,
'sb940ade1bd81be7e': `Under vänster`,
'sb9e9a7dd45966756': `Markera markeringen som fet`,
'sba509fd8ed61d1d5': `Osparad fil`,
'sba64d8954d027206': `Opacitet`,
'sba88d90cd6c751b3': `Regel för kolumn`,
'sbaf0a7c417e388af': `Hälsa`,
'sbb15d427ee1aa676': `Tigrinja`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filter för bakgrundsbilder`,
'sbb85a407d730e13d': `Lägg till en sökning`,
'sbb86c6c96f598bb8': `Blandad`,
'sbba0156f795d8c07': `Redigera val`,
'sbba865d4b437944f': `Attribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Avinstallera`,
'sbc5f2a81604baf9b': `Rubrik 6`,
'sbc5f2b81604bb14e': `Rubrik 5`,
'sbc5f2c81604bb301': `Rubrik 4`,
'sbc5f2d81604bb4b4': `Rubrik 3`,
'sbc5f2e81604bb667': `Rubrik 2`,
'sbc6953a36ced943f': `Integritetspolicy`,
'sbd181cd54b8402a4': `Redigera urvalet`,
'sbd35ee879d9cf770': `Ruby text`,
'sbd40f40cbadd38d5': `Ta bort detta widgetpaket`,
'sbd72dc858de95ce8': `Burmesiska`,
'sbe3c60c65f129daa': `Humaniora`,
'sbe4a7c8f231739b3': `eller klistra in/droppa/plocka fil`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Infoga en radbrytning`,
'sbf00e1ee999ea94e': `Infoga ett skript`,
'sbf519920c2017d67': `Upphängning`,
'sbfa01f189a68d3e9': `Flex växa`,
'sbff54e740c4086eb': `Visa okända paket`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkmen`,
'sc1611c0558728a2a': `Position`,
'sc1a155cc25899250': `Grupp av tabellrader`,
'sc1aa1f6051b7102a': `rumänska`,
'sc1edebeaef92b7bd': `Fast tabellayout`,
'sc1fff4f356dfb2fb': `Omvandla`,
'sc24bda3c061fddf8': `Klickbart område`,
'sc252a4e091763606': `Infoga en tabellfot`,
'sc2536e077514accc': `Rullning`,
'sc275dd00036d16cb': `Citat karaktär`,
'sc28864200d2a3799': `Kopiera QR-koden som bild`,
'sc2a24a9dd41a9503': `Dekorationslinje`,
'sc2b734cca2fa643b': `Pan (nedåt)`,
'sc2e2a0dbf03723b7': `Avancerat: Visa paket från okända källor i pakethanteraren (Varning: Kan vara osäkert)`,
'sc3998b77d72c2932': `Infoga en webbplats (som en inline-ram)`,
'sc3ac225273c8316b': `Allmänt`,
'sc3cfee84dbbf36ae': `Lokal fil`,
'sc3f09a9b6fa4fbed': `Insidan`,
'sc43767deea72e9f3': `Beskrivning Lista`,
'sc462bbdd36bcba6b': `Referenslåda`,
'sc4ee3e4ee994dafd': `Ukrainska`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Perspektivets ursprung (y)`,
'sc52e8b794c0913d6': `Perspektivets ursprung (x)`,
'sc53de149fcaad713': `Mellan karaktärer`,
'sc546f489f9c0cced': `Växlar testläge för det aktiva dokumentet`,
'sc5bcf50d1b578d9f': `Inställningar för teckensnittsfunktioner`,
'sc5cb39478b9b7625': `Markera urvalet som en subskription`,
'sc6415b50ff928294': `Lista objekt`,
'sc650ff15b20fe9d3': `Rotera (z)`,
'sc6578b15b2154365': `Rotera (x)`,
'sc65aff15b2183e58': `Rotera (y)`,
'sc6da0f4a7e4d710e': `Åsidosättande av teckensnittsspråk`,
'sc74e3567875ce255': `Både taggen för din widget och namnet på ditt NPM-paket`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Flytta (x)`,
'sc8af536e2084ade0': `Palett`,
'sc8b022f92b992bc2': `Flytta (y)`,
'sc8b39af92b9c2d81': `Flytta (z)`,
'sc8d2c7f6c33a2b32': `Ange textstil (justering, indragning, avstånd etc.) för markerade element`,
'sc8fa0e3de389ef1c': `Justera teckenstorlek`,
'sc9474bf7a0668d73': `Sammanfattning`,
'sc94e314312a8900c': `Tjeckien`,
'sc980855a000b76ea': `Botten`,
'sc98b103772de63f4': `Finska`,
'sca7cfe2bef51b2a5': `Rot`,
'sca7fed2bef53cb99': `Roll`,
'scabe6ecee5e01fd2': `Maltesisk`,
'scace301a88231cce': `Bädda in`,
'scbc55f622ec078c1': `Visa ruta`,
'scbe537fc38ff4c13': `Automatiska kolumner i rutnätet`,
'scc1db59d292cbc4c': `Sektion`,
'scc56b218a2689c42': `Armeniska`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Stoppningslåda`,
'scd9cedeb5ece3adb': `Bindestreck`,
'scdf536b65be39ec5': ` Skapa/importera`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografisk`,
'sceecdd0bb404bc17': `Infoga en alternativgrupp`,
'scf00d48fd5953a03': `Grekiska`,
'scf932840a69dbb7c': `Portugisiska`,
'scf932a8577057752': `Sidfot`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Längst ner till höger`,
'sd01178c54f648118': `Balansera kolumner`,
'sd03bff50f87f82d4': `Skriv med bindestreck`,
'sd05a155fe09c2866': `Online när du använder`,
'sd0864ea6cb6ef22e': `Gemenskap`,
'sd10fdbe6caf9a998': `Linjeavbrott`,
'sd121d3b959b7888d': `Optimera hastigheten`,
'sd1a78e667a1a139f': `Markera valet som en infogning`,
'sd1cffad290ea5b3b': `Behåll alla`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-post`,
'sd1f81984eeb7c0e8': `Fylla`,
'sd29dc07235eea0f5': `Offert`,
'sd2addf69477cd4b4': `Importpaket`,
'sd2ed26defc646d47': `Filter för bakgrundsbilder`,
'sd2ef82b8ea877c6d': `afrikaans`,
'sd319aae1401f1e19': `Fast`,
'sd3a288c1094b8a63': `Kolumnens regelbredd`,
'sd3c65ef5c380c046': `Insats`,
'sd3dcb76f7b28adb8': `Lettiska`,
'sd3eca1e0f4209f6e': `Trimma alla`,
'sd3f402df8619ddcd': `Den här informationen om dig läggs automatiskt till i nya dokument. Du kan ändra
          detta för varje dokument i metadataredigeraren.`,
'sd4368b12645d3c0f': `Infoga en portal`,
'sd452cebf4a0313d1': `Visa kommandon för källredigering`,
'sd48cc52117f4d68b': `Italienska`,
'sd52660ee947ca58b': `Infoga en tabellkolumn`,
'sd588d17a1b25c220': `Överflöd av text`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Högre utbildning.`,
'sd5cf95145e4d89ca': `Plocka bort denna snutt`,
'sd5fd9d11a92f5b1d': `Längst ner till vänster (y)`,
'sd60c9bbc51375635': `Infoga en knapp`,
'sd66c4767fa3dde28': `Accentfärg`,
'sd679c8b1bf8cc8a5': `Småbolag`,
'sd7086c4425c53c80': `Fontfamilj`,
'sd837f42ac7cbfb58': `Form (utsida)`,
'sd88076d2994ee0fb': `Uteslutning`,
'sd89a2e529b31ef43': `Återgå`,
'sd8a345e95668b73b': `Vertikal, från höger till vänster`,
'sd8ce9e57270b030d': `Teckensnittssträckning`,
'sd8ecf227c7c49331': `Matematisk`,
'sd8f923198e0c5c6a': `Slut`,
'sd9c21e5f60d6bdd8': `Dansk`,
'sd9ff8e2612e63d50': `Storlek på kantrutor`,
'sda2d76b976502a8d': `Öppna...`,
'sda344aacb837387e': `Position i behållaren`,
'sda5b6fa8b771f996': `Flytande vänster`,
'sda9254d1f1228e1a': `Ungerska`,
'sdb1595f5c742dfbb': `Ingång`,
'sdb711380a28fec75': `Infoga en lista (ordnad)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Nere till höger (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Georgiska`,
'sdd1ff479d04ac140': `Allmänheten`,
'sdd2fc8919a9c3111': `Blandningsläge för bakgrund`,
'sdd35b688281b6dea': `Japanska`,
'sddc49047f66a64ab': `Ingen beskrivning lämnas`,
'sdef34fe08bb28b09': `Kinesiska (förenklad)`,
'sdf62e305e1594805': `Markera urvalet med en ruby-annotation`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Inriktning`,
'se036b53f145441cd': `Blandat innehåll`,
'se06f459fccdc3ce9': `Justera sista textraden`,
'se0a782a8be8e018b': `Norska`,
'se0cda6b80a1bb50f': `Slovakien`,
'se0f67eae944f8f94': `Mute`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikel`,
'se1f5bb0386c88f96': `Ställer in färgen på den markerade texten`,
'se219da7b1e955c65': `Tydlig formatering`,
'se25e4f2cb77b8be8': `Språk för WebWriter-gränssnittet och nya dokument`,
'se2796c5824ec8916': `Synlighet för innehåll`,
'se308836a594808b6': `Singalesiska`,
'se36c5b1baf5e0660': `Var som helst`,
'se39c065efa467782': `baskiska`,
'se3b4c857f91f80d7': `Kortkommandon på tangentbordet`,
'se47baf2fd16b9d2b': `Mall`,
'se48bd9e6c2a3109d': `Konton`,
'se58467472725ad0c': `Bildupplösning`,
'se58f06c2b0583ff7': `Välj koordinater`,
'se5dc1e97fb743ade': `Avstånd`,
'se619a501d1bfe6a5': `Omslag`,
'se62385ac082368d2': `Markera urvalet som en källa för citering`,
'se6297163cac9d276': `Redigera källa`,
'se633223a0b88625e': `Placering av celler`,
'se638417c560cfe5c': `Bryt in`,
'se64f418b4e733b6c': `Infoga en utgång`,
'se6cdad455e2d8c02': `Infoga en division`,
'se79c0a3ac70d8fb3': `Asp. förhållande (x)`,
'se79fae3ac710dc36': `Asp. förhållande (y)`,
'se7fad370d8fb4cec': `Optimera läsbarheten`,
'se8a94b4effa2033e': `Alfabetisk`,
'se95d4e55ea186d9a': `Färg på rullningslisten`,
'se96d43a515b8451c': `Slovenska`,
'se96fd76ba1b2975a': `Central`,
'se9ac05f36b004eb0': `Dölj introduktionsrundan. Avaktivera så att rundturen visas igen.`,
'se9b1fec72ffd8f48': `Lokal`,
'sea24bdcaa2bd2dec': `Obligatorisk snap`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Växlar metadataredigeraren`,
'sea896ed51ad33287': `Inga specifika modeller tillgängliga`,
'seaaaeb09e3b4e78b': `Kommandon för redigering`,
'seabae79729c4b2ad': `Växla e-post`,
'seaecc8267bad6234': `Mellanstadiet`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Undvik kolumn`,
'seb4e52ef5ec7a7dc': `Färger/Effekter`,
'seb8982ae8c3cdcc5': `Indonesiska`,
'sebbced89e0db2894': `Första baslinjen`,
'sec02109a0dd2a6c8': `Betoning av färg`,
'sec2557a35b702525': `Variabel`,
'sec2da4aa7a02b925': `Isländska`,
'sec30fbb20f102670': `Infoga sammanfattning`,
'sec8b0b6c729816b6': `Huvudgrupp`,
'seccd05955adb76bc': `Affisch`,
'sed17285cd25d6389': `Katalog där package.json finns`,
'sed318ec045c5144f': `Över`,
'sed713f1b916fb469': `Avstånd mellan kanter (x)`,
'sed74a31b9172942c': `Avstånd mellan kanter (y)`,
'sed86bd0deb2e5372': `Förvandla text`,
'see2fcaedf9743ec6': `Plats`,
'seec6798afe90ffc8': `Skriv ut`,
'sef00c258bc1ecf1e': `Denna explorable har oavslutade ändringar.`,
'sef23dd271edd4a8b': `Längst ner till vänster`,
'sef24caccbd4645ef': `Flex krympning`,
'sef49aec68fd1dc66': `Namn`,
'sef73fe18e351eb35': `Nyckelord`,
'sef75f458d77491af': `Alternativgrupp`,
'sefcf950b3cc4fc3b': `Språk`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Innehåll`,
'sf0cab2483f66aa2e': `Anpassad`,
'sf0e261e04eda82ff': `Utseende`,
'sf1045382c1fd9a85': `Exakta tryckfärger`,
'sf14c35392ec7bf10': `Den här funktionen är inte tillgänglig i Firefox. Den är tillgänglig i Chrome eller Edge.`,
'sf14f9d5f9f6ca342': `Plus tändare`,
'sf1868dc19e3917bb': `Spanska`,
'sf190149f9d8bbb2a': `Skrivläge`,
'sf1e79171c4856543': `Är du säker på det? Denna åtgärd kan inte återkallas, alla dina inställningar kommer
          att raderas och återställas.`,
'sf21c1f60c7515f44': `Markera urvalet som provutskrift`,
'sf21fb4f4b9e8911f': `Bredd`,
'sf22a3737146ec910': `WebWriter kan bädda in SVG direkt i dokumentet.`,
'sf2514d5dc78b1654': `Infoga widget`,
'sf28903d4ca0ddcfc': `Ta bort detta konto`,
'sf2ab37af0abc55ef': `Göm intro-tur`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Ändra storlek både horisontellt och vertikalt`,
'sf2d5cbc2fe0ad65a': `Klistrig`,
'sf2d96d0eb32cb81f': `Komposition av animationer`,
'sf2de3dbe2108637a': `Rendering av form`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Lägga till ett spår`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Kassera ändringar`,
'sf4849bc200e279ed': `Bildtext till tabellen`,
'sf486ca1fdbe08645': `Infoga en figur`,
'sf4b537d4cbd8f5fd': `Text överst`,
'sf4e0e02a5277ef23': `Infoga en textarea`,
'sf4f067d41efd4b83': `Skala (y)`,
'sf4f3cbd41f002b46': `Skala (x)`,
'sf4fa67d41f05a008': `Skala (z)`,
'sf5197db2d5f2926a': `Rotera`,
'sf52d840949a980d1': str`
          ${0}
          kommer att raderas permanent. Är du säker på det? 
        `,
'sf55d634dcc743595': `Tjänster`,
'sf59c9081d106dd9c': `Markera urvalet som en variabel`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Ta bort ett dokument`,
'sf65df67a03bebe4b': `Krävs för denna widget`,
'sf6673729c03ae999': `Återställ WebWriter`,
'sf67571992e7dc88e': `Hela mandatperioden`,
'sf6b4934598f7ed10': `Tillåt val`,
'sf6e1665c7022a1f8': `Lösenord`,
'sf79e0d78b56444f1': `Inline-ände`,
'sf7a5f7a7c80c3082': `Båda`,
'sf7c0eba7c822e3d6': `Fet stil`,
'sf86bd4d2982f3b74': `Markera urvalet som kod`,
'sf8e82313fa411494': `Markera valet som en länk`,
'sf955eff73fb6b573': `Serbiska`,
'sf9929e2d356260c5': `Multiplicera`,
'sf993bb199fefbe04': `Alla`,
'sf9ecf969dd4b8164': `Båda kanterna`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privat tillgång`,
'sfa59c7777e2a0eeb': `Infoga en datalista`,
'sfaa0a67db5c11f72': `Indrag av första textraden`,
'sfb231a52211b133f': `Ingen ombrytning av text`,
'sfb68cae41d749423': `Inledande`,
'sfb9b6edb0ed378c9': `Citationskälla`,
'sfbbab09dbe553571': `Infoga en vektorritning (SVG)`,
'sfc00292e778b67e2': `Mätare`,
'sfc63e31ac7c956ed': `Välj`,
'sfc815c9078bba30a': `Ladda ner QR-kod som bild`,
'sfcdd8e672c75b713': `Adress`,
'sfcebd18506f1e535': `Flöde`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Utgång`,
'sfdb1e4d90981a535': `Dela detta dokument`,
'sfdeef3dccf409f81': `Detta nyckelord är obligatoriskt för widgets`,
'sfe6e758ad2603c1d': `Magisterexamen`,
'sfee1c12daf838935': `Färgbränning`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Infoga en dialogruta`,
'sffa395f64ec6ac36': `Bulgariska`,
'sffdadf0a576fd802': `Höjd`,
'spaceKey': `Utrymme`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Upp`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  